<template>
<div class="d-flex justify-space-around align-center flex-column flex-sm-row">  
<footer inset app>
<v-row
      justify="center"
      no-gutters
    >
      <v-btn
      :dark="!executingOperation"
      :disabled="executingOperation"
      class="mx-2"
      color="#2b5d66"
      v-if="(draft || sentToValidation || validated || feeNotValid) && !createXmlPermission"
      @click="createPdf">
      {{ $t('review') }}  
      </v-btn>
      <v-btn
      :dark="!executingOperation"
      :disabled="executingOperation"
      class="mx-2"
      color="#2b5d66"
      v-if="!(draft || sentToValidation || validated || feeNotValid) && !deleted && !createXmlPermission"
      @click="getsignature">
      {{ $t('downloadSignature') }} 
      </v-btn>
      <v-btn
      class="mx-2"
      :dark="!executingOperation"
      :disabled="executingOperation"
      color="#2b5d66"
      v-if="!(draft || sentToValidation || validated || feeNotValid) && !cancelled  && !deleted && !createXmlPermission"
      @click="downloadExtended">
      {{ $t('downloadExtended') }}
      </v-btn>
      <v-btn
      class="mx-2"
      :dark="!executingOperation"
      :disabled="executingOperation"
      color="#2b5d66"
      v-if="!(draft || sentToValidation || validated || feeNotValid) && !cancelled  && !deleted && !createXmlPermission"
      @click="download">
      {{ $t('download') }}
      </v-btn>
      <v-btn
      :dark="!executingOperation"
      :disabled="executingOperation"
      class="mx-2"
      color="#2b5d66"
      v-if="(draft || feeNotValid) && deletePermission && !createXmlPermission && newInvoice.id > 0 && (loggedUser.username == newInvoice.user || newInvoice.user.length == 0)"
      @click="deleteInvoice">
      {{ $t('delete') }}
      </v-btn>
      <v-btn
      class="mx-2"
      :dark="invoiceChanged && !executingOperation"
      color="#2b5d66"
      :disabled="!invoiceChanged || executingOperation"
      v-if="(draft || sentToValidation || feeNotValid) && !createXmlPermission"
      @click="cancelChanges">
      {{ $t('discardChanges') }}
      </v-btn>
      <v-btn
      class="mx-2"
      :dark="invoiceChanged && !executingOperation"
      color="#2b5d66"
      :disabled="!invoiceChanged || executingOperation"
      v-if="(draft || sentToValidation || feeNotValid) && !createXmlPermission"
      @click="saveInvoice">
      {{ $t('saveChanges') }}
      </v-btn>
      <v-btn
      class="mx-2"
      :dark="!executingOperation"
      :disabled="executingOperation"
      color="#2b5d66"
      v-if="draft && !createXmlPermission && sendToValidationPermission && !fees"
      @click="sendToValidation">
      {{ $t('sendTovalidation') }}
      </v-btn>
      <v-btn
      class="mx-2"
      :dark="!executingOperation"
      :disabled="executingOperation"
      color="#2b5d66"
      v-if="sentToValidation && !createXmlPermission && validationPermission && !fees"
      @click="returnToDraft">
      {{ $t('return') }}
      </v-btn>
      <v-btn
      class="mx-2"
      dark
      color="#2b5d66"
      v-if="validated && !createXmlPermission && validateAndSendPermission && !fees"
      @click="returnToValidation">
      {{ $t('return') }}
      </v-btn>
      <v-btn
      class="mx-2"
      :dark="!executingOperation"
      :disabled="executingOperation"
      color="#2b5d66"
      v-if="sentToValidation && !createXmlPermission && validationPermission && !fees"
      @click="invoiceValidated">
      {{ $t('validate') }}
      </v-btn>
      <v-btn
      class="mx-2"
      :dark="!executingOperation"
      :disabled="executingOperation"
      color="#2b5d66"
      v-if="(draft || validated || feeNotValid) && !createXmlPermission && sendPermission && (!sendToValidationPermission || fees)"
      @click="sendInvoice">
      {{ $t('sendDocument') }}
      </v-btn>
      <v-btn
      class="mx-2"
      :dark="!executingOperation"
      :disabled="executingOperation"
      color="#2b5d66"
      v-if="(draft || mistake) && cancelPermission && !createXmlPermission && (loggedUser.username == newInvoice.user || newInvoice.user.length == 0)"
      @click="cancel">
      {{ $t('cancel') }}
      </v-btn>
      <v-btn
      class="mx-2"
      :dark="!executingOperation"
      :disabled="executingOperation"
      color="#2b5d66"
      v-if="(sent || approved || rejected) && stornoPermission && !createXmlPermission && (loggedUser.username == newInvoice.user || newInvoice.user.length == 0)"
      @click="storno">
      {{ $t('storno') }}
      </v-btn>
      <v-btn
      class="mx-2"
      :dark="!executingOperation"
      :disabled="executingOperation"
      color="#2b5d66"
      v-if="createXmlPermission"
      @click="createXml">
      {{ $t('sendXml') }}
      </v-btn>
    </v-row>
  </footer>
<!--  Pop up notification  -->        
<!--  <v-snackbar v-model="showSnackbar" class="mb-5">
    {{ snackbarText }}

    <template v-slot:action="{ attrs }">
      <v-btn color="pink" text v-bind="attrs" @click="showSnackbar = false">
        Close
      </v-btn>
    </template>
  </v-snackbar> -->
  <CancelDialog :cancelInvoice="cancelInvoice" ref="cancelDialog" />
  <StornoDialog :stornoInvoice="stornoInvoice" ref="stornoDialog" />
  <UserToValidateDialog :userToValidate="userToValidate" ref="UserToValidateDialog" />
  <UserToSendDialog :userToSend="userToSend" ref="UserToSendDialog" />
  <UserToReturnDialog :userToReturn="userToReturn" ref="UserToReturnDialog" />
  <ValidationCommentDialog :validationInvoice="validationInvoice" ref="ValidationCommentDialog" />
</div>
</template>

<script>
import CancelDialog from "../components/CancelDialog.vue"
import StornoDialog from "../components/StornoDialog.vue"
import UserToValidateDialog from "../components/UserToValidateDialog.vue"
import UserToSendDialog from "../components/UserToSendDialog.vue"
import UserToReturnDialog from "../components/UserToReturnDialog.vue"
import ValidationCommentDialog from "../components/ValidationCommentDialog.vue"
export default {
  name: "InvoiceFooter",
  components: {
      CancelDialog,
      StornoDialog,
      UserToValidateDialog,
      UserToSendDialog,
      UserToReturnDialog,
      ValidationCommentDialog
  },
  props: ['newInvoice'],
  data() {
    return {
      showSnackbar: false,
      showCancelComment: false,
      showStornoComment: false,
      snackbarText: "",
      cancelInvoice: {
        invoiceId: "",
        cancelComments: ""
      },
      stornoInvoice: {
        invoiceId: "",
        stornoNumber: "", 
        stornoComment: ""
      }, 
      userToValidate: {
        userId: ""
      },
      userToSend: {
        userId: ""
      },
      userToReturn: {
        userId: "",
        comment: ""
      },
      validationInvoice: {
        invoiceId: "",
        comment: ""
      },
      executingOperation: false
    };
  },
  computed: {
    draft() {
      return this.$parent.newInvoice.statusId == 2
    },
    sentToValidation() {
      return this.$parent.newInvoice.statusId == 19
    },
    validated() {
      return this.$parent.newInvoice.statusId == 20
    },
    sent() {
      return this.$parent.newInvoice.statusId == 3
    },
    approved() {
      return this.$parent.newInvoice.statusId == 10
    },
    rejected() {
      return this.$parent.newInvoice.statusId == 11
    },
    deleted() {
      return this.$parent.newInvoice.statusId == 9
    },
    cancelled() {
      return this.$parent.newInvoice.statusId == 12
    },
    feeNotValid() {
      return this.$parent.newInvoice.statusId == 21
    },
    mistake() {
      return this.$parent.newInvoice.statusId == 5
    },
    fees() {
      return this.$parent.newInvoice.documentType.documentTypeId >= 5
    },
    loggedUser() {
      return this.$store.getters.loggedUser;
    },
    selectedOrganization() {
      return this.$store.getters.organizationId
    },
    createXmlPermission() {
      const isFound = this.loggedUser.permission.some(element =>{
        if(element.permission === 'CreateXml' && element.organizationId === this.selectedOrganization)
          return true;
      });
      return isFound;
    },
    deletePermission() {
      const isFound = this.loggedUser.permission.some(element =>{
        if(element.permission === 'DeleteSalesInvoice' && element.organizationId === this.selectedOrganization)
          return true;
      });
      return isFound;
    },
    cancelPermission() {
      const isFound = this.loggedUser.permission.some(element =>{
        if(element.permission === 'CancelSalesInvoice' && element.organizationId === this.selectedOrganization)
          return true;
      });
      return isFound;
    },
    stornoPermission() {
      const isFound = this.loggedUser.permission.some(element =>{
        if(element.permission === 'StornoSalesInvoice' && element.organizationId === this.selectedOrganization)
          return true;
      });
      return isFound;
    },
    sendToValidationPermission() {
      const isFound = this.loggedUser.permission.some(element =>{
        if(element.permission === 'SendSalesInvoiceToValidation' && element.organizationId === this.selectedOrganization)
          return true;
      });

      return isFound;
    },
    validationPermission() {
      const isFound = this.loggedUser.permission.some(element =>{
        if(element.permission === 'Validation' && element.organizationId === this.selectedOrganization)
          return true;
      });
      return isFound;
    },
    validateAndSendPermission() {
      const isFound = this.loggedUser.permission.some(element =>{
        if(element.permission === 'ValidateAndSend' && element.organizationId === this.selectedOrganization)
          return true;
      });
      return isFound;
    },
    sendPermission() {
      const isFound = this.loggedUser.permission.some(element =>{
        if(element.permission === 'SendSalesInvoice' && element.organizationId === this.selectedOrganization)
          return true;
      });
      return isFound;
    },
    invoiceChanged() {
      console.log(this.$parent.hasChanged)
      console.log('initialInvoice:')
      console.log(this.$parent.initialInvoice)
      console.log('newInvoice:')
      console.log(this.$parent.newInvoice)
      console.log('createNewInvoice')
      console.log(this.$parent.createNewInvoice)
      return this.$parent.hasChanged
    }

  },
  methods: {
    validation() {
      return this.$parent.$refs.invoiceForm.validate()
    },
    createPdf() {
      this.executingOperation = true;
      if(this.validation() || !this.$config.CreatePDFValidation) {
        var formData = new FormData();
        if(this.newInvoice.files && this.newInvoice.files.length > 0){
          for(let i = 0; i < this.newInvoice.files.length; i++)
            formData.append('files', this.newInvoice.files[i]);
        }
        formData.append('invoiceJson', JSON.stringify(this.newInvoice))
        
        this.axios.post('SalesInvoices/GeneratePdf?organizationId=' + this.$store.getters.organizationId, formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }, responseType: 'arraybuffer',
              }).then(response => {
                this.executingOperation = false;
                var fileURL = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
                window.open(fileURL, '_blanck')
              }, (error) => {
                              console.log("Error: " + error);
                              console.log(error);
              })
        }
        else {
          this.$root.displayNotificationMsg(this.$t('dataRequired'), 'warning');
          this.executingOperation = false;
        }
    },
    saveInvoice() {
      this.executingOperation = true;
      if(this.validation()){
        var formData = new FormData();

        if(this.newInvoice.files && this.newInvoice.files.length > 0){
          for(let i = 0; i < this.newInvoice.files.length; i++)
            formData.append('files', this.newInvoice.files[i]);
        }
        
        formData.append('invoiceJson', JSON.stringify(this.newInvoice))
        this.axios.post('SalesInvoices/SaveInvoiceWithFormattedValues?organizationId=' + this.$store.getters.organizationId, formData, {
              headers: {
                  "Content-Type": "multipart/form-data"
              }
            }).then(response => {
              if(response.data.message != null) {
                this.$root.displayNotificationMsg(response.data.message, 'warning');
                //this.$parent.getInovicesNumbers();
                this.$parent.$refs.invoiceNumberRef.focus();
                this.executingOperation = false;
                return
              }
              else if(response && response.status === 200) {
                //let id = this.$parent.initialInvoice.id
                this.$parent.newInvoice = response.data
                //this.$parent.calculateTotal() //premesteno ispod zbog fortamiranja
                this.$parent.initialInvoice = JSON.parse(JSON.stringify(this.$parent.newInvoice))
                this.$root.displayNotificationMsg(this.$t('invoiceSavedMessage', {invoice: this.newInvoice.invoice}), 'success')
                //this.$parent.calculateTotal()
                //if(id != this.$parent.initialInvoice.id)
                //  this.$router.push({ name: 'InvoiceForm', query: {id: this.$parent.initialInvoice.id }, replace: true})
                if(this.$parent.initialInvoice.documentType.documentTypeId < 5)
                  this.$router.push({ name: 'ArchivoOutput'})
                else
                  this.$router.push({ name: 'ArchivoFeeOutput'})
              }
        })
        .catch(function (error) {
            console.log(error)
            if (error.response) {
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            }
            else if (error.request) {
              console.log(error.request);
            } 
        })
      }
      else {
        this.$root.displayNotificationMsg(this.$t('dataRequired'), 'warning');
        this.executingOperation = false;
      }
    },
    sendInvoice() {
      this.executingOperation = true;
      if(this.validation()){
        var formData = new FormData();
        if(this.newInvoice.files && this.newInvoice.files.length > 0){
          for(let i = 0; i < this.newInvoice.files.length; i++)
            formData.append('files', this.newInvoice.files[i]);
        }
        formData.append('invoiceJson', JSON.stringify(this.newInvoice))
        this.axios.post('SalesInvoices/SendInvoiceWithFormattedValues?organizationId=' + this.$store.getters.organizationId + '&hasChanged=' + this.$parent.hasChanged + '&sendToCir=' + this.newInvoice.cir, formData, {
              headers: {
                  "Content-Type": "multipart/form-data"
              }
            })
            .then(response => {
              if(response.data.message != null && response.data.id <= 0) {
                this.$root.displayNotificationMsg(response.data.message, 'warning');
                this.$parent.$refs.invoiceNumberRef.focus();
                this.executingOperation = false;
                return
              }
              else if(response.data.message != null && response.data.id > 0) {
                if(response.data.id != this.$parent.initialInvoice.id) {
                  this.$parent.newInvoice.id = response.data.id;
                  this.$router.push({ name: 'InvoiceForm', query: {id: response.data.id }, replace: true});
                }

                this.$root.displayNotificationMsg(response.data.message, 'warning');
                this.executingOperation = false;
                return
              }
              else if(response && response.status === 200) {
                this.$parent.newInvoice = response.data;
                this.$parent.initialInvoice = JSON.parse(JSON.stringify(this.$parent.newInvoice));
                this.$root.displayNotificationMsg(this.$t('invoiceSentMessage', {invoice: this.newInvoice.invoice}), 'success');
                                
                if(this.$parent.initialInvoice.documentType.documentTypeId < 5)
                  this.$router.push({ name: 'ArchivoOutput'});
                else
                  this.$router.push({ name: 'ArchivoFeeOutput'});
              }
        })
        .catch(err => console.log(err))
      }
      else {
        this.$root.displayNotificationMsg(this.$t('dataRequired'), 'warning');
        this.executingOperation = false;
      }
    },
    async cancelChanges() {
      if(this.$parent.hasChanged && await this.$confirm(this.$t('cancelChangesMessage'), { title: this.$t('warning'), buttonTrueText: this.$t('yes'), buttonFalseText: this.$t('no'), persistent: true }))
        this.$parent.newInvoice = JSON.parse(JSON.stringify(this.$parent.initialInvoice))
    },
    async deleteInvoice() {
      this.executingOperation = true;
      if(await this.$confirm(this.$t('invoiceDeleteMessage', {invoice: this.newInvoice.invoice}), { title: this.$t('warning'), buttonTrueText: this.$t('yes'), buttonFalseText: this.$t('no'), persistent: true })) {
        this.axios.delete('SalesInvoices/Delete/' + this.newInvoice.id).then((response) => {
              this.$parent.newInvoice = response.data
              this.$parent.initialInvoice = JSON.parse(JSON.stringify(this.$parent.newInvoice))
              this.$root.displayNotificationMsg(this.$t('invoiceDeleted', {invoice: this.newInvoice.invoice}), 'success')
              
              if(this.$parent.initialInvoice.documentType.documentTypeId < 5)
                  this.$router.push({ name: 'ArchivoOutput'});
              else
                  this.$router.push({ name: 'ArchivoFeeOutput'});
            })
            .catch(err => console.log(err))
      }     
      else {
        this.executingOperation = false;
      } 
    },
    getsignature() {
      this.executingOperation = true;
      this.axios({
        url: 'SalesInvoices/GetSalesInvoiceSignature?id=' + this.newInvoice.id + '&invoiceId=' + this.newInvoice.invoiceId + '&organizationId=' + this.$store.getters.organizationId,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {  
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
  
          fileLink.href = fileURL;
          fileLink.setAttribute('download', this.newInvoice.invoice + '_sgn.zip');
          document.body.appendChild(fileLink);
          this.executingOperation = false;
          fileLink.click();
        })
        .catch(err => console.log(err))
    },
    download() {
      this.executingOperation = true;
      this.axios({
        url: 'SalesInvoices/GetSalesInvoicePDF?id=' + this.newInvoice.id + '&invoiceId=' + this.newInvoice.invoiceId + '&organizationId=' + this.$store.getters.organizationId + '&invoiceNumber=' + this.newInvoice.invoice,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {  
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          var contetnType = response.headers['content-type'];
  
          fileLink.href = fileURL;
          if(contetnType.includes('zip')){
            fileLink.setAttribute('download',  this.newInvoice.invoice + '.zip');
          }
          else{
            fileLink.setAttribute('download',  this.newInvoice.invoice + '.pdf');
          } 
          document.body.appendChild(fileLink);
          this.executingOperation = false;
          fileLink.click();
          //this.filterInvoices();
        })
        .catch(err => console.log(err))
    },
    downloadExtended() {
      this.executingOperation = true;
      this.axios({
        url: 'SalesInvoices/GetSalesInvoiceExtendedPDF?id=' + this.newInvoice.id + '&invoiceId=' + this.newInvoice.invoiceId + '&organizationId=' + this.$store.getters.organizationId + '&invoiceNumber=' + this.newInvoice.invoice,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {  
        console.log(response.data)
        if(response.data.type != "application/pdf") {
            this.$root.displayNotificationMsg(this.$t('requestAccepted'), 'success');
            this.executingOperation = false;
            return
          }
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          var contetnType = response.headers['content-type'];
  
          fileLink.href = fileURL;
          fileLink.setAttribute('download',  this.newInvoice.invoice + '.pdf');
          document.body.appendChild(fileLink);
          this.executingOperation = false;
          fileLink.click();
          //this.filterInvoices();
        })
        .catch((error) => { 
                        console.log("!!Error: " + error);
                        console.log(error.response.data);
                        this.$root.displayNotificationMsg(error.response.data.message, 'warning'); 
                    })
    },
    async cancel() {
      this.executingOperation = true;
      const confirmation = await this.$refs.cancelDialog.showDialog();
      if (confirmation === 'ok') {
        var formData = new FormData()
        this.cancelInvoice.invoiceId = this.newInvoice.invoiceId
        formData.append('cancelInvoice', JSON.stringify(this.cancelInvoice))
        this.axios.post('SalesInvoices/CancelInvoice?id=' + this.newInvoice.id + '&organizationId=' + this.$store.getters.organizationId + '&statusId=' + this.$parent.newInvoice.statusId, formData).then((response) => {
                this.$parent.initialInvoice = response.data
                this.$parent.newInvoice = JSON.parse(JSON.stringify(this.$parent.initialInvoice))
                this.$root.displayNotificationMsg(this.$t('invoiceCanceled', {invoice: this.newInvoice.invoice}), 'success')
                if(this.$parent.initialInvoice.documentType.documentTypeId < 5)
                  this.$router.push({ name: 'ArchivoOutput'})
                else
                  this.$router.push({ name: 'ArchivoFeeOutput'})
              })
              .catch(err => console.log(err))
        }
      else {
        this.executingOperation = false;
      }
    },
    async storno() {
      this.executingOperation = true;
      const confirmation = await this.$refs.stornoDialog.showDialog();
      if (confirmation === 'ok'){
        var formData = new FormData()
        this.stornoInvoice.invoiceId = this.newInvoice.invoiceId
        formData.append('stornoInvoice', JSON.stringify(this.stornoInvoice))
        this.axios.post('SalesInvoices/StornoInvoice?id=' + this.newInvoice.id + '&organizationId=' + this.$store.getters.organizationId, formData).then((response) => {
                if(response.data.message != null)
                  this.$root.displayNotificationMsg(response.data.message, 'warning')
                else {
                  this.$parent.initialInvoice = response.data
                  this.$parent.newInvoice = JSON.parse(JSON.stringify(this.$parent.initialInvoice))
                  this.$root.displayNotificationMsg(this.$t('invoiceStorno', {invoice: this.newInvoice.invoice}), 'success')
                  if(this.$parent.initialInvoice.documentType.documentTypeId < 5)
                    this.$router.push({ name: 'ArchivoOutput'})
                  else
                    this.$router.push({ name: 'ArchivoFeeOutput'})
                  }
              })
              .catch(err => console.log(err))
      }
      else {
        this.executingOperation = false;
      }
    },
    async sendToValidation() {
      this.executingOperation = true;
      if(this.validation()){
        const confirmation = await this.$refs.UserToValidateDialog.showDialog()
         if (confirmation === 'ok') {
           var formData = new FormData();

            if(this.newInvoice.files && this.newInvoice.files.length > 0){
              for(let i = 0; i < this.newInvoice.files.length; i++)
                formData.append('files', this.newInvoice.files[i]);
            }
            
            formData.append('invoiceJson', JSON.stringify(this.newInvoice))
            this.axios.post('SalesInvoices/SaveInvoiceWithFormattedValues?organizationId=' + this.$store.getters.organizationId, formData, {
                  headers: {
                      "Content-Type": "multipart/form-data"
                  }
                }).then(response => {
                  if(response.data.message != null) {
                    this.$root.displayNotificationMsg(response.data.message, 'warning');
                    //this.$parent.getInovicesNumbers();
                    this.$parent.$refs.invoiceNumberRef.focus();
                    this.executingOperation = false;
                    return
                  }
                  else if(response && response.status === 200) {
                    this.$parent.newInvoice = response.data
                    
                      this.axios.post('SalesInvoices/SendToValidation?id=' + this.$parent.newInvoice.id + '&userToValidateId=' + this.userToValidate.userId).then((response) => {
                            this.$parent.initialInvoice = response.data
                            this.$parent.newInvoice = JSON.parse(JSON.stringify(this.$parent.initialInvoice))
                            if(this.newInvoice.invoice.length > 0)
                              this.$root.displayNotificationMsg(this.$t('invoiceSentToValidation', {invoice: this.newInvoice.invoice}), 'success')
                            else
                              this.$root.displayNotificationMsg(this.$t('sentToValidation'), 'success')
                            this.$router.push({ name: 'ArchivoOutput'})
                          })
                          .catch(err => console.log(err))
                  }
            })
            .catch(function (error) {
                console.log(error)
                if (error.response) {
                  console.log(error.response.data);
                  console.log(error.response.status);
                  console.log(error.response.headers);
                }
                else if (error.request) {
                  console.log(error.request);
                } 
            })
         }
         else {
          this.executingOperation = false;
         }
      }
      else {
        this.$root.displayNotificationMsg(this.$t('dataRequired'), 'warning');
        this.executingOperation = false;
      }
    },
    async invoiceValidated() {
      this.executingOperation = true;
      if(this.validation()){
        const confirmation = await this.$refs.UserToSendDialog.showDialog()
        if (confirmation === 'ok'){
          var formData = new FormData();

            if(this.newInvoice.files && this.newInvoice.files.length > 0){
              for(let i = 0; i < this.newInvoice.files.length; i++)
                formData.append('files', this.newInvoice.files[i]);
            }
            
            formData.append('invoiceJson', JSON.stringify(this.newInvoice))
            this.axios.post('SalesInvoices/SaveInvoiceWithFormattedValues?organizationId=' + this.$store.getters.organizationId, formData, {
                  headers: {
                      "Content-Type": "multipart/form-data"
                  }
                }).then(response => {
                  if(response.data.message != null) {
                    this.$root.displayNotificationMsg(response.data.message, 'warning');
                    this.$parent.$refs.invoiceNumberRef.focus();
                    this.executingOperation = false;
                    return
                  }
                  else if(response && response.status === 200) {
                    this.$parent.newInvoice = response.data
                    
                      this.axios.post('SalesInvoices/InvoiceValidated?id=' + this.$parent.newInvoice.id + '&userToValidateId=' + this.userToSend.userId).then((response) => {
                        this.$parent.initialInvoice = response.data
                        this.$parent.newInvoice = JSON.parse(JSON.stringify(this.$parent.initialInvoice))
                        this.$root.displayNotificationMsg(this.$t('InvoiceSentToValidation', {invoice: this.newInvoice.invoice}), 'success')
                        this.$router.push({ name: 'ArchivoOutput'})
                      })
                      .catch(err => console.log(err))
                  }
            })
            .catch(function (error) {
                console.log(error)
                if (error.response) {
                  console.log(error.response.data);
                  console.log(error.response.status);
                  console.log(error.response.headers);
                }
                else if (error.request) {
                  console.log(error.request);
                } 
            })
        }
        else {
          this.executingOperation = false;
        }
      }
      else {
        this.$root.displayNotificationMsg(this.$t('dataRequired'), 'warning');
        this.executingOperation = false;
      }
    },
    async returnToValidation() {
      this.executingOperation = true;
      const confirmation = await this.$refs.UserToReturnDialog.showDialog();
      if (confirmation === 'ok'){
        this.axios.post('SalesInvoices/ReturnToValidation?id=' + this.newInvoice.id + '&userToReturnId=' + this.userToReturn.userId + '&comment=' + this.userToReturn.comment).then((response) => {
              this.$parent.initialInvoice = response.data
              this.$parent.newInvoice = JSON.parse(JSON.stringify(this.$parent.initialInvoice))
              this.$root.displayNotificationMsg(this.$t('invoiceReturned', {invocie: this.newInvoice.invoice}), 'success')
              this.$router.push({ name: 'ArchivoOutput'})
            })
            .catch(err => console.log(err))
      }
      else {
        this.executingOperation = false;
      }
    },
    async returnToDraft() {
      this.executingOperation = true;
      const confirmation = await this.$refs.ValidationCommentDialog.showDialog()
      if (confirmation === 'ok'){
        this.axios.post('SalesInvoices/ReturnToDraft?id=' + this.newInvoice.id + '&comment=' + this.validationInvoice.comment).then((response) => {
              this.$parent.initialInvoice = response.data
              this.$parent.newInvoice = JSON.parse(JSON.stringify(this.$parent.initialInvoice))
              this.$root.displayNotificationMsg(this.$t('invoiceReturned', {invocie: this.newInvoice.invoice}), 'success')
              this.$router.push({ name: 'ArchivoOutput'})
            })
            .catch(err => console.log(err))
      }
      else {
        this.executingOperation = false;
      }
    },
    createXml() {
      this.executingOperation = true;
      if(this.validation()){
        var formData = new FormData();
        if(this.newInvoice.files && this.newInvoice.files.length > 0){
          for(let i = 0; i < this.newInvoice.files.length; i++)
            formData.append('files', this.newInvoice.files[i]);
        }
        formData.append('invoiceJson', JSON.stringify(this.newInvoice))
        this.axios.post('SalesInvoices/SendXML?organizationId=' + this.$store.getters.organizationId, formData, {
              headers: {
                  "Content-Type": "multipart/form-data"
              }
            })
            .then(response => {
              if(response && response.status === 200) {
                this.$parent.initialInvoice = JSON.parse(JSON.stringify(this.$parent.newInvoice));
                this.$root.displayNotificationMsg(this.$t('invoiceSentMessage', {invoice: this.newInvoice.invoice}), 'success');
                this.$router.push({ name: 'NewInvoice', replace: true});
              }
        })
        .catch(err => console.log(err))
      }
      else {
        this.$root.displayNotificationMsg(this.$t('dataRequired'), 'warning');
        this.executingOperation = false;
      }
    }
  }
};
</script>

<style scoped>
</style>